// const listeners = {};
// export default {
//   $on(eventName, callback) {
//     if (!listeners[eventName]) {
//       listeners[eventName] = new Set();
//     }
//     listeners[eventName].add(callback);
//   },
//   $off(eventName, callback) {
//     if (!listeners[eventName]) {
//       return;
//     }
//     listeners[eventName].delete(callback);
//   },
//   $emit(eventName, ...args) {
//     if (!listeners[eventName]) {
//       return;
//     }
//     listeners[eventName].forEach((callback) => {
//       callback(...args);
//     });
//   },
// };

// 或者直接使用一个vue实例

/*
 * 事件名：mainScroll
 * 含义：主区域滚动条位置变化后触发
 * 参数：
 * - 滚动的dom元素，如果是undefined，则表示dom元素已经不存在
 *
 * 事件名：setMainScroll
 * 含义：当需要设置主区域滚动条位置时触发
 * 参数：
 * - 滚动高度
 */

import Vue from "vue";
const app = new Vue({});

Vue.prototype.$bus = app;

export default app;
